import { Component, Input, Output, EventEmitter } from '@angular/core';
import type { Button } from '../../modules/dynamic-form-builder/model/formBuilderInterface';
import { InfoIconComponent } from '../info-icon/info-icon.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: true,
  imports: [CommonModule, InfoIconComponent]
})
export class ButtonComponent {
  @Input() btnField: Button;
  @Input() isEditMode = false;
  @Input() loadingLabel = '';
  @Output() handleButtonClick = new EventEmitter<string>();

  get label(): string {
    return this.isEditMode ? this.btnField.editLabel : this.btnField.label;
  }

  handleClick() {
    this.handleButtonClick.emit(this.btnField.name);
  }
}
